import React, { Component } from 'react';
import Loader from '../../Loader/components/Loader';

import './Overlay.css';

const DEFAULT_ZINDEX = 2000;
const RETREAT_ZINDEX = 1800;

class Overlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: true,
      showLoader: false,
      style: {
        zIndex: DEFAULT_ZINDEX,
      },
    };

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  toFront() {
    this.setState({
      style: {
        zIndex: DEFAULT_ZINDEX,
      },
    });
  }

  toBack() {
    this.setState({
      style: {
        zIndex: RETREAT_ZINDEX,
      },
    });
  }

  show(loader = false) {
    this.setState({
      hidden: false,
      showLoader: loader,
    });
  }

  hide() {
    this.setState({
      hidden: true,
      showLoader: false,
    });
  }

  render() {
    const { hidden, style, showLoader } = this.state;
    return (
      <div className={hidden ? 'hidden' : 'overlay'} style={style}>
        {showLoader
          && <Loader />}
      </div>
    );
  }
}

export default Overlay;
